<ng-container [ngSwitch]="cellDataTypes[element.rowIndex][columnId].inputType">
    <ng-container
        *ngSwitchCase="
            cellDataTypes[element.rowIndex][columnId].inputType === 'STRING' ||
            cellDataTypes[element.rowIndex][columnId].inputType === 'INT' ||
            cellDataTypes[element.rowIndex][columnId].inputType === 'LONG' ||
            cellDataTypes[element.rowIndex][columnId].inputType === 'DOUBLE'
                ? cellDataTypes[element.rowIndex][columnId].inputType
                : ''
        ">
        <material-input
            [placeholder]="column.name"
            [title]="element.errors?.[columnId]?.length > 0 ? element.errors?.[columnId]?.[0] : element.warnings?.[columnId]?.length > 0 ? element.warnings?.[columnId]?.[0] : element.errors?.[columnId]?.errors?.length > 0 ? element.errors?.[columnId]?.errors?.[0] : element.errors?.[columnId]?.warnings?.length > 0 ? element.errors?.[columnId]?.warnings?.[0] : column.name"
            [model]="element[columnId]"
            [debounceAfter]="1000"
            (modelChange)="element[columnId] = $event"
            [required]="false"
            [description]="column.name"
            [errors]="element.errors?.[columnId]?.errors"
            [warnings]="element.errors?.[columnId]?.warnings"
            [appearance]="'outline'"
            [noHints]="true"
            [tailwindClasses]="['border-0', 'py-0']"
            (debounceEventHandler)="columnValueChanged()"></material-input>
    </ng-container>
    <ng-container *ngSwitchCase="'DATE'">
        <material-input-date
            [placeholder]="column.name"
            [label]="column.name"
            [title]="element.errors?.[columnId]?.length > 0 ? element.errors?.[columnId]?.[0] : element.warnings?.[columnId]?.length > 0 ? element.warnings?.[columnId]?.[0] : column.name"
            [model]="element[columnId]"
            [debounceAfter]="1000"
            [required]="false"
            [description]="column.name"
            [dateFormat]="cellDataTypes[element.rowIndex][columnId].outputFormat"
            [inputOnlyDisabled]="true"
            (modelChange)="element[columnId] = $event"
            [errors]="element.errors[columnId].errors"
            [warnings]="element.errors[columnId].warnings"
            (debounceEventHandler)="columnValueChanged()"></material-input-date>
    </ng-container>
    <span *ngSwitchCase="'BOOLEAN'">
        <div class="d-flex justify-content-between booleanFieldContainer gridBooleanvalues">
            <div class="booleanValues">
                <material-radio-group
                    [radioOptions]="[
                        { value: 'true', displayName: 'Yes' },
                        { value: 'false', displayName: 'No' }
                    ]"
                    [selectedValue]="element[columnId]"
                    (selectionChanged)="element[columnId] = $event"
                    [name]="column.name + element.rowIndex + element.columnIndex"
                    [ariaLabel]="'Select an option'"
                    [radioGroupClassList]="['custom-radio-group']"
                    [radioButtonClassList]="['custom-radio-button']"></material-radio-group>
            </div>
        </div>
    </span>
    <ng-container *ngSwitchCase="'LOOKUP'">
        <app-assetlookup
            [field]="field"
            [errors]="element.errors[columnId].errors"
            [name]="column.name"
            [required]="false"
            [gridCellIndex]="gridCellIndex"
            (modelChange)="element[columnId] = $event; field.value = $event"></app-assetlookup>
    </ng-container>
</ng-container>
